import { useEffect, useCallback, useRef } from 'react';
import useMainStore from '../store/mainState';
import client from '../lib/apollo-client';
import { BALANCE_UPDATED_SUBSCRIPTION } from '../graphql/subscriptions';

const useBalanceSubscription = () => {
    const { user, setUser } = useMainStore();
    const setUserRef = useRef(setUser);
    
    // Keep setUser ref updated without triggering re-subscription
    useEffect(() => {
        setUserRef.current = setUser;
    }, [setUser]);

    useEffect(() => {
        
        // Don't subscribe if no user
        if (!user?.id) {
            return;
        }

        const userId = Number(user.id);

        let subscription: any = null;

        try {
            // Create subscription observable - exactly like admin panel
            const observable = client.subscribe({
                query: BALANCE_UPDATED_SUBSCRIPTION,
                variables: { userId },
            });

            subscription = observable.subscribe({
                next: (result) => {
                    
                    if (result.data?.balanceUpdated) {
                        const updatedData = result.data.balanceUpdated;
                        
                        const updatedUser = {
                            ...user,
                            ...updatedData,
                        };
                        setUserRef.current(updatedUser);
                        
                        // Dispatch custom event for backward compatibility
                        window.dispatchEvent(new CustomEvent('balanceUpdated', {
                            detail: updatedData.Balance || updatedData
                        }));
                        
                    } 
                },
                error: (error) => {
                    console.error('[Balance Subscription] ❌ Subscription error:', error);
                },
                complete: () => {
                },
            });

        } catch (error) {
            console.error('[Balance Subscription] ❌ Failed to create subscription:', error);
        }

        // Cleanup function
        // return () => {
        //     if (subscription) {
        //         subscription.unsubscribe();
        //         subscription = null;
        //     }
        // };
    }, [user?.id]); // Removed setUser from dependencies to prevent re-subscription
};

export default useBalanceSubscription;
